import Charge from './ChargeSetup';

export default Charge;
